<template>
  <div class="messageWrap">
    <triggernav :triggerval="triggerval"></triggernav>
    <ul class="messagebox" v-if="messagelist.length > 0">
      <li
        class="newsitem"
        v-for="(item, index) in messagelist"
        :key="item.id"
        @click="openmsg(index, item.id)"
      >
        <div :class="{ itembox: true, active: msgIndex === item.id }">
          <h4 :class="{ clearfix: true, unread: !item.unread || item.see }">
            <em class="fl"></em>
            <span class="newtitle fl">{{
              item.title ? item.title : "无标题"
            }}</span
            ><span class="newstiem fr">{{ item.createTime }}</span>
          </h4>
          <div class="itemcon" v-show="msgIndex === item.id">
            {{ item.content }}
          </div>
        </div>
      </li>
    </ul>

    <noneHint
      :noneListhint="noneListhint"
      v-if="messagelist.length <= 0"
    ></noneHint>
  </div>
</template>

<script>
import { AuthorNotice, noticed } from "apiurl/notice";
export default {
  data() {
    return {
      triggerval: {
        chooseVal: ["作家新闻", "评论回复"],
        chooseIndex: 0 // 切换信息：基本 签约
      },
      msgIndex: 0,
      messagelist: [],
      noneListhint: {
        msg: "还没有更多的消息~~",
        isbtn: false,
        istype: "notice"
      }
    };
  },
  created() {
    this.getMessage(1, 1, 10);
  },
  methods: {
    openmsg(index, id) {
      this.msgIndex = id;
      this.messagelist.forEach(element => {
        if (element.id == id) {
          element.see = true;
        }
      });
    },
    // 获取消息列表
    async getMessage(sort, pageNo, size) {
      let msg = await AuthorNotice({
        sort: sort,
        pageNo: pageNo,
        pageSize: size
      });
      if (msg) {
        if (msg.success) {
          if (msg.data.items.length > 0) {
            this.messagelist = msg.data.items;
            this.msgIndex = this.messagelist[0].id;
            this.messagelist[0].see = true;
            this.messagelist.forEach(item => {
              item.createTime = item.createTime.slice(0, 10);
            });
          }
        }
      }
    }
  },
  mounted() {
    let that = this;
    window.onbeforeunload = function() {
      that.messagelist.forEach(item => {
        if (item.see) {
          if (item.unread) {
            noticed(
              that.qs.stringify({
                noticeId: item.id
              })
            );
          }
        }
      });
    };
  },
  beforeDestroy() {
    this.messagelist.forEach(item => {
      if (item.see) {
        if (item.unread) {
          noticed(
            this.qs.stringify({
              noticeId: item.id
            })
          );
        }
      }
    });
  }
};
</script>
<style></style>
<style lang="stylus" scoped>
.messagebox
    width 100%
    margin 24px 0
    .newsitem
        border-bottom 1px solid #D3D3D3
        .itembox
            padding 0 14px 0px
            margin 0 14px
            &.active
                border:1px solid rgba(197,224,233,1);
                padding 0 14px 10px
                background rgba(237, 248, 252, 1)
                margin 10px 14px
                h4
                    color #25A5CF
                    &.unread
                        color #25A5CF;
                        em
                            background #25A5CF
                    .newstiem
                        display none
                    em
                        background #25A5CF
            h4
                height 40px
                line-height 40px
                font-size 14px
                color rgba(51, 51, 51, 1)
                &.unread
                    color #888888;
                    em
                        background:rgba(136,136,136,1);
                em
                    width 5px
                    height 5px
                    background rgba(248, 81, 81, 1)
                    opacity 0.88
                    margin-top 17px
                    margin-right 7px
                    display inline-block
                    border-radius 50%
            .itemcon
                padding 14px 0
                background rgba(255, 255, 255, 1)
                border:1px solid rgba(211,211,211,1);
                color #333333
                font-size 12px
                // display none
</style>
